import BaseDropdown from "../components/HelperComponents/BaseDropdown";
import Progress from "../components/HelperComponents/Progress";
import CheckBox from "../components/HelperComponents/CheckBox";
import GroupDropdown from "../components/HelperComponents/GroupDropdown";
import Modal from "../components/HelperComponents/Modal";
import Onboarding from "../components/HelperComponents/Onboarding";
import SwipeTut from "../components/HelperComponents/SwipeTut";
import MainNav from "../components/home-layouts/MainNav";
import MainSidebarRight from "../components/home-layouts/MainSidebarRight";
import HomeMainContent from "../components/home-layouts/HomeMainContent";
import PostType from "../components/home-layouts/PostType";
import ReactionEmoji from "../components/home-layouts/ReactionEmoji";
import HomeMainNav from "../components/home-layouts/HomeMainNav";
import HeaderBottom from "../components/layouts/HeaderBottom";
import Sidebar from "../components/layouts/Sidebar";
import MainContent from "../components/MainContent";
import SidebarRight from "../components/layouts/SidebarRight";
import ChatSidebar from "../components/ChatComponents/ChatSidebar";
import DirectChatList from "../components/ChatComponents/DirectChatList";
import GroupChatList from "../components/ChatComponents/GroupChatList";
import DirectChatDetails from "../components/ChatComponents/DirectChatDetails";
import GroupChatTopBar from "../components/ChatComponents/GroupChatTopBar";
import DirectChatTopBar from "../components/ChatComponents/DirectChatTopBar";
import ChatBox from "../components/ChatComponents/ChatBox";
import BlockUnblock from "../components/ChatComponents/BlockUnblock";
import ProfileInfo from "../components/ProfileComponents/ProfileInfo";
import ProfileStatistic from "../components/ProfileComponents/ProfileStatistic";
import ProfileActivity from "../components/ProfileComponents/ProfileActivity";
import Posts from "../components/ProfileComponents/Posts";
import SeriesPost from "../components/ProfileComponents/SeriesPost";
import SocialMediaSelect from "../components/ProfileComponents/SocialMediaSelect";
import BadgesModal from "../components/ProfileComponents/BadgesModal";
import ProfileEditModal from "../components/ProfileComponents/ProfileEditModal";
import FollowersModal from "../components/ProfileComponents/FollowersModal";
import FollowingModal from "../components/ProfileComponents/FollowingModal";
import PostDetails from "../components/PostDetails/Comment";
import Shoutouts from "../components/PostDetails/Shoutouts";
import HTMLTextarea from "../components/PostDetails/Components/HTMLTextarea";
import SidebarPost from "../components/PostDetails/SidebarPost";
import SidebarPostSeries from "../components/PostDetails/SidebarPostSeries";
import SidebarSeries from "../components/PostDetails/SidebarSeries";
import TranscriptModal from "../components/PostDetails/TranscriptModal";
import PostDetailsModal from "../components/PostDetails/PostDetailsModal";
import PostDetailsComponent from "../components/PostDetails/Components/PostDetailsComponent";
import SeriesSuggestion from "../components/PostDetails/Components/SeriesSuggestion";
import PostComments from "../components/PostDetails/Components/PostComments";
import PostShare from "../components/PostDetails/Components/PostShare";
import CommentReaction from "../components/PostDetails/Components/CommentReaction";

export default {
  install(Vue) {
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(Progress.name, Progress);
    Vue.component(MainNav.name, MainNav);
    Vue.component(MainSidebarRight.name, MainSidebarRight);
    Vue.component(HomeMainContent.name, HomeMainContent);
    Vue.component(PostType.name, PostType);
    Vue.component(ReactionEmoji.name, ReactionEmoji);
    Vue.component(HomeMainNav.name, HomeMainNav);
    Vue.component(GroupDropdown.name, GroupDropdown);
    Vue.component(CheckBox.name, CheckBox);
    Vue.component(HeaderBottom.name, HeaderBottom);
    Vue.component(Sidebar.name, Sidebar);
    Vue.component(MainContent.name, MainContent);
    Vue.component(SidebarRight.name, SidebarRight);
    Vue.component(Modal.name, Modal);
    Vue.component(Onboarding.name, Onboarding);
    Vue.component(SwipeTut.name, SwipeTut);
    Vue.component(ChatSidebar.name, ChatSidebar);
    Vue.component(DirectChatList.name, DirectChatList);
    Vue.component(GroupChatList.name, GroupChatList);
    Vue.component(DirectChatDetails.name, DirectChatDetails);
    Vue.component(GroupChatTopBar.name, GroupChatTopBar);
    Vue.component(DirectChatTopBar.name, DirectChatTopBar);
    Vue.component(ChatBox.name, ChatBox);
    Vue.component(BlockUnblock.name, BlockUnblock);
    Vue.component(ProfileInfo.name, ProfileInfo);
    Vue.component(ProfileStatistic.name, ProfileStatistic);
    Vue.component(ProfileActivity.name, ProfileActivity);
    Vue.component(Posts.name, Posts);
    Vue.component(SeriesPost.name, SeriesPost);
    Vue.component(SocialMediaSelect.name, SocialMediaSelect);
    Vue.component(BadgesModal.name, BadgesModal);
    Vue.component(ProfileEditModal.name, ProfileEditModal);
    Vue.component(FollowersModal.name, FollowersModal);
    Vue.component(FollowingModal.name, FollowingModal);
    Vue.component(PostDetails.name, PostDetails);
    Vue.component(Shoutouts.name, Shoutouts);
    Vue.component(HTMLTextarea.name, HTMLTextarea);
    Vue.component(SidebarPost.name, SidebarPost);
    Vue.component(SidebarPostSeries.name, SidebarPostSeries);
    Vue.component(SidebarSeries.name, SidebarSeries);
    Vue.component(TranscriptModal.name, TranscriptModal);
    Vue.component(PostDetailsModal.name, PostDetailsModal);
    Vue.component(PostDetailsComponent.name, PostDetailsComponent);
    Vue.component(SeriesSuggestion.name, SeriesSuggestion);
    Vue.component(PostComments.name, PostComments);
    Vue.component(PostShare.name, PostShare);
    Vue.component(CommentReaction.name, CommentReaction);
  }
};
